
<template>
  <div>
    <ul>
      <li
        class="offer_list_li"
        v-for="item in offerList"
        :key="item.id"
        @click="goGoodsDetails(item.fields.goods_id)"
      >
        <div class="offer_list_li_div_1">
          <img class="offer_list_li_div_img" :src="item.fields.image_url">
        </div>
        <div class="offer_list_li_div_name">{{item.fields.goods_name}}</div>
        <div class="offer_list_home_top">
          <div class="home_good_text" v-if="item.fields.is_prom === 1">限时特价</div>
          <div class="home_good_text" v-if="item.fields.is_vip === 1">会员专享</div>
        </div>
        <div class="offer_list_home_price">
          <span class="offer_list_home_price_span">¥</span>
          {{item.fields.min_price | moneySwitch}}
        </div>
        <div class="offer_list_home_bottom">
          <div class="offer_list_home_bottom_left">
            <span class="offer_list_home_price_span">¥</span>
            {{item.fields.max_price | moneySwitch}}
          </div>
          <div
            class="offer_list_home_bottom_right"
            v-if="item.fields.team_count > 0 "
          >已拼{{item.fields.team_count}}件</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
/* eslint-disable handle-callback-err */
/* eslint-disable semi */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable */
import { recommendGoods } from "@/request/api";
import { moneySwitch, getUrlKey } from "@/util/util";
export default {
  data() {
    return {
      offerList: []
    };
  },
  filters: {
    moneySwitch(money) {
      return moneySwitch(money);
    }
  },
  created() {
    this.getRecommendGoods();
  },
  methods: {
    // 会员商品
    getRecommendGoods() {
      recommendGoods({})
        .then(res => {
          this.offerList = res.result.items;
        })
        .catch(err => {
          this.$toast.center("请求错误会员商品");
        });
    },
    // 点击会员商品跳转商品详情
    goGoodsDetails(goodsId) {
      let ua = navigator.userAgent.toLowerCase();
      // Android终端
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      // Ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        window.webkit.messageHandlers.goGoodsDetails.postMessage({
          goodsId: goodsId // vue给iOS传值
        });
      } else if (/(Android)/i.test(navigator.userAgent)) {
        $App.goGoodsDetails(goodsId); // vue给android传值
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/css/function.scss";
.offer_list_li:nth-child(odd) {
  float: left;
}
.offer_list_li:nth-child(even) {
  float: right;
}
.offer_list_li {
  display: block;
  background: #fff;
  width: 47.5%;
  height: px2rem(552px);
  margin-top: px2rem(23px);
  margin-bottom: px2rem(12px);
  border-radius: px2rem(10px);
  .offer_list_li_div_1 {
    width: 100%;
    height: px2rem(296px);
    margin-top: px2rem(20px);
    .offer_list_li_div_img {
      width: 100%;
      height: 100%;
    }
  }
  .offer_list_li_div_name {
    width: 92%;
    margin-left: px2rem(15px);
    height: px2rem(70px);
    line-height: px2rem(40px);
    margin-top: px2rem(15px);
    font-size: px2rem(28px);
    color: #333;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .offer_list_home_top {
    width: 92%;
    margin-left: px2rem(15px);
    height: px2rem(40px);
    margin-top: px2rem(10px);
    .home_good_text {
      font-size: px2rem(18px);
      float: left;
      height: px2rem(30px);
      padding: px2rem(1px) px2rem(8px);
      line-height: px2rem(30px);
      border: 1px solid #ed5e3b;
      color: #ed5e3b;
      border-radius: px2rem(15px);
      margin-top: px2rem(3px);
      margin-right: px2rem(5px);
    }
  }
  .offer_list_home_price {
    width: 92%;
    margin-left: px2rem(15px);
    height: px2rem(40px);
    line-height: px2rem(40px);
    margin-top: px2rem(15px);
    color: #ed5e3b;
    font-size: px2rem(30px);
    .offer_list_home_price_span {
      font-size: px2rem(22px);
    }
  }
  .offer_list_home_bottom {
    width: 92%;
    margin-left: px2rem(15px);
    height: px2rem(30px);
    line-height: px2rem(30px);
    color: #999;
    font-size: px2rem(24px);
    .offer_list_home_bottom_left {
      float: left;
    }
    .offer_list_home_bottom_right {
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/goodsList.vue